const state = {
  ref: {},
  data: {},
  clients: [],
  clientSelected: null,
  desktop: false,
  clientUser: null,
  // desktop: true,
  app: false,
  printer: false,
  reload: false,
  service: false
};

const debounce = (fn, delay) => {
  let timeoutId;
  return function() {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      fn.apply(this, arguments);
    }, delay);
  };
};

const mutations = {
  SET_CLIENTS(state, { clients }) {
    state.clients = clients;
  },
  CLIENT_SELECTED(state, { client }) {
    state.clientSelected = client;
    console.log(
      `CLIENT_SELECTED state.clientSelected: ${state.clientSelected}`
    );
  },
  SET_USER_DATA(state, { user }) {
    state.ref = user.ref;
    state.data = user.data();

    // try {
    //   const names = state.data.name.split(" ");
    //   const firstName = names[0];
    //   if (names.length > 1) names.shift();
    //   const lastName = names.join(" ");

    //   const Email = state.data.email;
    //   const crm_user_properties = {
    //     "First name": firstName,
    //     "Last name": lastName,
    //     City: state.data.ipInfo ? state.data.ipInfo.city : "",
    //     Country:
    //       state.data.account && state.data.account.country
    //         ? state.data.account.country.name
    //         : "",
    //     Mobile:
    //       state.data.account &&
    //       state.data.account.company &&
    //       state.data.account.company.phone
    //         ? `+${state.data.account.company.phone.country_code} ${state.data.account.company.phone.phone_number}`
    //         : ""
    //   };
    //   fwcrm.set({ Email, ...crm_user_properties });
    //   fwcrm.identify(Email, crm_user_properties);
    // } catch (e) {
    //   console.log(e);
    // }

    // window.intercomSettings = {
    //   api_base: "https://api-iam.intercom.io",
    //   app_id: "ja4de1g1"
    // };

    let country;
    if (state.data.account) {
      if (
        state.data.account.onboarding &&
        state.data.account.onboarding.location
      ) {
        country = state.data.account.onboarding.location.country;
      } else if (state.data.account.country) {
        country = state.data.account.country.code;
      }
    }

    console.log("country", country);
    if (country && country !== "IL") {
      if (country !== "IL") {
        window.$crisp = [];
        window.CRISP_WEBSITE_ID = "791d729d-10c6-4050-971e-42e46abe71cb";
        (function() {
          const d = document;
          const s = d.createElement("script");
          s.src = "https://client.crisp.chat/l.js";
          s.async = 1;
          d.getElementsByTagName("head")[0].appendChild(s);
        })();

        if (state.data.name) {
          // window.intercomSettings["name"] = state.data.name;
          window.$crisp.push(["set", "user:nickname", [state.data.name]]);
        }
        if (state.data.email) {
          // window.intercomSettings["email"] = state.data.email;
          window.$crisp.push(["set", "user:email", [state.data.email]]);
        }

        // (function() {
        //   var w = window;
        //   var ic = w.Intercom;
        //   if (typeof ic === "function") {
        //     ic("reattach_activator");
        //     ic("update", w.intercomSettings);
        //   } else {
        //     var d = document;
        //     var i = function() {
        //       i.c(arguments);
        //     };
        //     i.q = [];
        //     i.c = function(args) {
        //       i.q.push(args);
        //     };
        //     w.Intercom = i;
        //     var l = function() {
        //       var s = d.createElement("script");
        //       s.type = "text/javascript";
        //       s.async = true;
        //       s.src = "https://widget.intercom.io/widget/ja4de1g1";
        //       var x = d.getElementsByTagName("script")[0];
        //       x.parentNode.insertBefore(s, x);
        //     };
        //     if (document.readyState === "complete") {
        //       l();
        //     } else if (w.attachEvent) {
        //       w.attachEvent("onload", l);
        //     } else {
        //       w.addEventListener("load", l, false);
        //     }
        //   }
        // })();
      }
    }

    // window.intercomSettings['language_override'] = if user selected a lang;
    // Intercom("update", window.intercomSettings);

    if (state.desktop || state.app) {
      if (state.data.computer) {
        state.data.computer.collection("printers").onSnapshot(printers => {
          debounce(() => {
            state.reload = true;
          }, 1000);
        });
      }
    }

    if (state.data.computer) {
      const serviceCollection = state.data.computer.collection("service");
      serviceCollection
        .get()
        .then(querySnapshot => (state.service = !querySnapshot.empty))
        .catch(function(e) {
          console.error('[user] service.get failed:', e);
        });
    }
  },
  SET_USER_PROPERTY(state, { property, value }) {
    state.data[property] = value;
  },
  SET_USER_UNSUBSCRIBE(state, { unsubscribe }) {
    state.unsubscribe = unsubscribe;
  }
};
const actions = {
  async subscribe({ commit, rootState }, user) {
    return new Promise((resolve, reject) => {
      var unsubscribe = user.onSnapshot(user => {
        if (user.exists) {
          commit("SET_USER_DATA", { user });
        } else {
          unsubscribe();
        }
        resolve();
      });
      commit("SET_USER_UNSUBSCRIBE", { unsubscribe });
    });
  },
  unsubscribe({ commit, rootState }) {
    if (state.unsubscribe != null) {
      state.unsubscribe();
    }
    state.ref = {};
    state.data = {};
    state.clients = [];
    state.service = false;
  },
  set_property({ commit, rootState }, pair) {
    state[pair.property] = pair.value;
  },
  async dataFetched({ commit, rootState }, clients) {
    commit("SET_CLIENTS", { clients });
  },
  async clientSelected({ commit, rootState }, client) {
    commit("CLIENT_SELECTED", { client });
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js